module.exports = __webpack_public_path__ + "img/1553611894.58aac63e.jpg";